<template>
	<!-- 关于我们 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>
		
		<nemunav :list="navList" navBgImg="service" :menutitle="menutitle"  @tapMenu="tapMenu"  :navIndex="selectIndex"></nemunav>

		<service1 v-if="selectIndex==0"></service1>
		<service2 v-if="selectIndex==1"></service2>
		<service3 v-if="selectIndex==2"></service3>

		<footer1></footer1>
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>  
</template>

<script>   
import {
	  
	} from '@/api/home.js';
import mobilemenu from "@/components/en/mobile-menu.vue";
	import header1 from "@/components/en/header.vue";
	import nemunav from "@/components/en/nemunav.vue";
	import footer1 from "@/components/en/footer.vue";
	import service1 from "@/components/en/service/index1.vue";
	import service2 from "@/components/en/service/index2.vue";
	import service3 from "@/components/en/service/index3.vue";
	export default {
		components: {
			header1,
			footer1,
			nemunav,
			service1,
			service2,
			service3,
			mobilemenu
		},
		data() {
			return {
				pathname: "/en/service",
				menutitle:"Service",
				navList:["Development and Investment", "Engineering general contractor", "Operation and maintenance services"],
				selectIndex:0,
				isShowMobile:false
			}
		},
		created() {
			this.selectIndex = this.$route.query.index?this.$route.query.index:0

		},
		methods: {
			tapMenu(e) {
				console.log("oooiiii")
				this.selectIndex = e
				
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			}

		}
	}
</script>

<style lang="scss">
	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;
		}
	
	}
	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;
		}
	
	}
	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px; 
		}
	
	}
</style>
